<template>
  <div class="svgBox" :style="{ color: color }">
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 523 236" class="design-iconfont">
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 3.5L523 3.5"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 43.5L523 43.5"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 83.5L523 83.5"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 123.5L523 123.5"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 163.5L523 163.5"/>
      <path d="M0 204H523V205H0V204Z" fill="currentColor" fill-opacity=".1"/>
      <path
          d="M2.5 103.5C15 101.167 31.2203 96 50 96C72 96 80.1676 98.081 93 96C111.5 93 122.5 91.5 137.5 86C152.5 80.5 161.5 78.5 180.5 81C194.885 82.8927 203.572 90.5 228 86C247 82.5 259.5 69.9999 278.5 68.9999C297.5 67.9999 311 70 323.5 74C336 78 340.5 86 364 86C376.5 86 392.5 86 408 86C423.5 86 430.5 89.5 440 90.5C449.5 91.5 467 96 479 96C488.6 96 506.833 96 512.5 96"
          stroke="currentColor" stroke-opacity=".4" stroke-width="2" stroke-linecap="round"/>
      <path
          d="M4.5 88.9999C13.5 96.6666 35.5 112 51.5 112C71.5 112 92.923 77.7543 105 67.9999C118 57.5001 128 56.8658 141 57.4999C161.5 58.5 186.105 77.2118 207 99.4999C214.5 107.5 229 111 248 104C267 97 269.5 74 288.5 73C307.5 72 317.5 88.9999 334.5 88.9999C351.5 88.9999 374.5 86 394.5 88.9999C417.246 92.4117 421.5 99.4999 440.5 99.4999C459.5 99.4999 498.5 99.4999 514.5 99.4999"
          stroke="currentColor" stroke-opacity=".2" stroke-width="2" stroke-linecap="round"/>
      <path fill="#fff" d="M4 84A4 4 0 1 0 4 92A4 4 0 1 0 4 84Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M4 85A3 3 0 1 0 4 91A3 3 0 1 0 4 85Z"/>
      <path fill="#fff" d="M4 99A4 4 0 1 0 4 107A4 4 0 1 0 4 99Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M4 100A3 3 0 1 0 4 106A3 3 0 1 0 4 100Z"/>
      <path fill="#fff" d="M47 92A4 4 0 1 0 47 100A4 4 0 1 0 47 92Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M47 93A3 3 0 1 0 47 99A3 3 0 1 0 47 93Z"/>
      <path fill="#fff" d="M99 89A4 4 0 1 0 99 97A4 4 0 1 0 99 89Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M99 90A3 3 0 1 0 99 96A3 3 0 1 0 99 90Z"/>
      <path fill="#fff" d="M140 79A4 4 0 1 0 140 87A4 4 0 1 0 140 79Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M140 80A3 3 0 1 0 140 86A3 3 0 1 0 140 80Z"/>
      <path fill="#fff" d="M231 82A4 4 0 1 0 231 90A4 4 0 1 0 231 82Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M231 83A3 3 0 1 0 231 89A3 3 0 1 0 231 83Z"/>
      <path fill="#fff" d="M282 64A4 4 0 1 0 282 72A4 4 0 1 0 282 64Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M282 65A3 3 0 1 0 282 71A3 3 0 1 0 282 65Z"/>
      <path fill="#fff" d="M326 69A4 4 0 1 0 326 77A4 4 0 1 0 326 69Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M326 70A3 3 0 1 0 326 76A3 3 0 1 0 326 70Z"/>
      <path fill="#fff" d="M415 81A4 4 0 1 0 415 89A4 4 0 1 0 415 81Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M415 82A3 3 0 1 0 415 88A3 3 0 1 0 415 82Z"/>
      <path fill="#fff" d="M466 89A4 4 0 1 0 466 97A4 4 0 1 0 466 89Z"/>
      <path stroke="currentColor" stroke-opacity=".4" stroke-width="2" d="M466 90A3 3 0 1 0 466 96A3 3 0 1 0 466 90Z"/>
      <path fill="#fff" d="M47 107A4 4 0 1 0 47 115A4 4 0 1 0 47 107Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M47 108A3 3 0 1 0 47 114A3 3 0 1 0 47 108Z"/>
      <path fill="#fff" d="M99 69A4 4 0 1 0 99 77A4 4 0 1 0 99 69Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M99 70A3 3 0 1 0 99 76A3 3 0 1 0 99 70Z"/>
      <path fill="#fff" d="M140 52A4 4 0 1 0 140 60A4 4 0 1 0 140 52Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M140 53A3 3 0 1 0 140 59A3 3 0 1 0 140 53Z"/>
      <path fill="#fff" d="M185 76A4 4 0 1 0 185 84A4 4 0 1 0 185 76Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M185 77A3 3 0 1 0 185 83A3 3 0 1 0 185 77Z"/>
      <path fill="#fff" d="M231 104A4 4 0 1 0 231 112A4 4 0 1 0 231 104Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2"
            d="M231 105A3 3 0 1 0 231 111A3 3 0 1 0 231 105Z"/>
      <path fill="#fff" d="M282 70A4 4 0 1 0 282 78A4 4 0 1 0 282 70Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M282 71A3 3 0 1 0 282 77A3 3 0 1 0 282 71Z"/>
      <path fill="#fff" d="M326 84A4 4 0 1 0 326 92A4 4 0 1 0 326 84Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M326 85A3 3 0 1 0 326 91A3 3 0 1 0 326 85Z"/>
      <path fill="#fff" d="M373 84A4 4 0 1 0 373 92A4 4 0 1 0 373 84Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M373 85A3 3 0 1 0 373 91A3 3 0 1 0 373 85Z"/>
      <path fill="#fff" d="M415 89A4 4 0 1 0 415 97A4 4 0 1 0 415 89Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M415 90A3 3 0 1 0 415 96A3 3 0 1 0 415 90Z"/>
      <path fill="#fff" d="M466 94A4 4 0 1 0 466 102A4 4 0 1 0 466 94Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M466 95A3 3 0 1 0 466 101A3 3 0 1 0 466 95Z"/>
      <path fill="#fff" d="M512 94A4 4 0 1 0 512 102A4 4 0 1 0 512 94Z"/>
      <path stroke="currentColor" stroke-opacity=".2" stroke-width="2" d="M512 95A3 3 0 1 0 512 101A3 3 0 1 0 512 95Z"/>
      <path fill="#86909C" d="M16.2183 208H16.781747V210.34211H16.2183z"/>
      <path fill="#86909C" d="M60.7637 208H61.327147V210.34211H60.7637z"/>
      <path fill="#86909C" d="M105.309 208H105.872447V210.34211H105.309z"/>
      <path fill="#86909C" d="M149.855 208H150.418447V210.34211H149.855z"/>
      <path fill="#86909C" d="M194.4 208H194.963447V210.34211H194.4z"/>
      <path fill="#86909C" d="M238.946 208H239.509447V210.34211H238.946z"/>
      <path fill="#86909C" d="M283.491 208H284.054447V210.34211H283.491z"/>
      <path fill="#86909C" d="M328.036 208H328.599447V210.34211H328.036z"/>
      <path fill="#86909C" d="M372.582 208H373.145447V210.34211H372.582z"/>
      <path fill="#86909C" d="M417.127 208H417.690447V210.34211H417.127z"/>
      <path fill="#86909C" d="M461.673 208H462.236447V210.34211H461.673z"/>
      <path fill="#86909C" d="M506.218 208H506.781447V210.34211H506.218z"/>
    </svg>
    <div class="no-data-text">当前无数据</div>
  </div>

</template>
<script>
export default {
  name: "noDataSvg",
  props: {
    color: {
      type: String,
      default: '#787A80',
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.svgBox {
  width: 100%;
  height: 94%;
  position: relative;

  svg {
    width: 100%;
    height: 100%;
  }

  .no-data-text {
    position: absolute;
    top: 65%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    opacity: 0.7;
  }
}
</style>
